import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { EvaluateSurveyResponse } from '../../services';

export const evaluateSurveyAction = createActionGroup({
  source: 'Evaluate survey',
  events: {
    'load evaluate survey': emptyProps(),

    'submit answer': emptyProps(),
    'submit answer success': props<{ response: EvaluateSurveyResponse }>(),
    'submit answer error': props<{ error: Error }>(),

    restart: emptyProps(),
  },
});
